var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_4030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 7.73997L5.30926 10.6303L6.60134 12.02C6.9924 12.4396 6.9924 13.1177 6.60134 13.5373C6.21027 13.9569 5.57831 13.9569 5.18725 13.5373L3.89204 12.1509L3.30545 12.7787L4.59909 14.1684C4.99015 14.588 4.99015 15.2661 4.59909 15.6857C4.20802 16.1053 3.57513 16.1053 3.18406 15.6857L1.18188 13.5373C0.790937 13.1177 0.790937 12.4396 1.18188 12.02L6.58569 6.22266C6.94547 6.83361 7.43039 7.35393 7.99978 7.73997Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 4.88889C5.3335 2.1888 7.52331 0 10.2224 0C12.9215 0 15.1113 2.1888 15.1113 4.88889C15.1113 7.58796 12.9215 9.77778 10.2224 9.77778C7.52331 9.77778 5.3335 7.58796 5.3335 4.88889ZM10.2224 7.60494C11.723 7.60494 12.9384 6.38951 12.9384 4.88889C12.9384 3.38895 11.723 2.17284 10.2224 2.17284C8.72177 2.17284 7.50634 3.38895 7.50634 4.88889C7.50634 6.38951 8.72177 7.60494 10.2224 7.60494Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_4030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ba34ce3c1f823e1d41b2387fc7268053.svg";
export { ForwardRef as ReactComponent };